import { render, staticRenderFns } from "./advisoryIndex.vue?vue&type=template&id=85825b8c&scoped=true&"
import script from "./advisoryIndex.vue?vue&type=script&lang=js&"
export * from "./advisoryIndex.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=85825b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85825b8c",
  null
  
)

export default component.exports